<template>
  <div>
    <NavBar />

    <div class="page-wrapper">
      <!-- Title above login box -->
      <div class="header-section">
        <h1 class="main-title">HE Customer Service Portal</h1>
        <p class="subtitle">
          Support patients, clinics, and providers with real-time information
        </p>
      </div>

      <!-- Login Box (EXACT COPY) -->
      <div class="login-container">
        <h2 class="text-center">Login</h2>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="email">Email:</label>
            <input
              type="email"
              id="email"
              v-model="email"
              placeholder="Enter your email"
              required
            />
          </div>

          <div class="form-group">
            <label for="password">Password:</label>
            <input
              type="password"
              id="password"
              v-model="password"
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit">Login</button>

          <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/RegNavbar.vue";
import axios from "axios";

export default {
  name: "HomeView",
  components: { NavBar },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async handleLogin() {
      if (this.email && this.password) {
        try {
          const response = await axios.post(`${process.env.VUE_APP_URL}/api/login`, {
            email: this.email,
            password: this.password,
          });

          const token = response.data.token;
          localStorage.setItem("token", token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          this.$router.push("/dashboard");
        } catch (error) {
          this.errorMessage =
            error.response?.data?.message || "Login failed. Try again.";
        }
      } else {
        this.errorMessage = "Please fill in all fields.";
      }
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
  padding: 40px 20px;
  background: linear-gradient(to bottom right, #f4f6f8, #ffffff);
}

.header-section {
  text-align: center;
  margin-bottom: 50px;
}

.main-title {
  font-size: 32px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 12px;
}

.subtitle {
  color: #555;
  font-size: 16px;
}

/* ✅ BIG FIX: Padding inside the login box content */
.login-container {
  max-width: 440px;
  width: 100%;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  padding: 0;
}

form {
  display: flex;
  flex-direction: column;
  padding: 32px; /* ✅ extra internal padding here */
  box-sizing: border-box;
}

h2 {
  text-align: center;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 18px;
  width: 100%;
}

label {
  font-weight: bold;
  margin-bottom: 6px;
  display: block;
}

input {
  padding: 12px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box; /* ✅ ensures input respects parent padding */
}

button {
  padding: 12px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  margin-top: 6px;
}

button:hover {
  background-color: #0056b3;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
}
</style>